import { RouteProps } from '../../routes/AppRouter'
import React from 'react'
import { Editor as UP } from '../../features/user-profile'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function UserProfile(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return <UP />
}
